import React, { Component } from "react";
import { UncontrolledTooltip, Badge } from "reactstrap";
import { log } from "util";
import { goToName } from "../oro-module/commonFunctions";
import { domainFunctions } from "../oro-module/domainFunctions";


class NumberOnlyCustom extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      extraClass: "",
      errorMessage: "",
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000)),
      val: ""
    };
  }
  generateID() {
    return this.state.ttid;
  }
  generateID2() {
    return this.state.ttid2;
  }


  handleChange(e) {
    let errorMessage = "";
    if (this.props.component.validations) {
      this.props.component.validations.map(validation => {
        let patt = new RegExp(validation.rule);
        // let result = validation.rule.exec(e.target.value);
        let result = patt.test(e.target.value)

        if (!result) {
          // if not required BUT something is entered.
          //
          if (
            (!this.props.component.isRequired &&
              String(e.target.value).length != 0) ||
            this.props.component.isRequired

          ) {
            this.setState({ errorMessage: validation.message });
            this.setState({ extraClass: "validationError" });
            errorMessage = validation.message;
          } else {
            this.setState({ errorMessage: "" });
            this.setState({ extraClass: "" });
            errorMessage = "";
          }
        } else {
          this.setState({ extraClass: "validationSuccess" });
          this.setState({ errorMessage: "" });
          errorMessage = "";
        }
      });
    }
    // Convert case. Remove (to disable) invalid chars. lift form errors to avoid form submission.
    let x = this.props.parentState.errorMessages;
    x[this.props.component.name] = errorMessage;
    this.props.liftGlobalState({ name: "errorMessages" }, x);

    const re = /^[0-9\b]+$/;
    if (e.target.value == "" || re.test(e.target.value)) {
      this.props.liftState(this.props.component, e.target.value);
    }

  }



  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, defaultValue } = this.props.component;
    if (
      pageData && !fileFolder.isOpen &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      defaultValue
    ) {
      this.props.liftState(this.props.component, defaultValue);
    }
  }
  render() {
    const {
      name,
      label,
      placeHolder,
      isRequired,
      description,
      mainHeader, isReadOnly, maxlength, insertonly, next_field
    } = this.props.component;
    let { fileFolder, formState, modalname, pageData, LocalVars, errorMessages } = this.props.parentState;
    let boxvalue;
    let { compressed, ShowHistory } = LocalVars;

    // let modalname=openmodals[openmodals.length-1];
    if (modalname && pageData[modalname]) {
      boxvalue = pageData[modalname][name]
        ? pageData[modalname][name]
        : "";
    } else {
      boxvalue = pageData[name]
        ? pageData[name]
        : "";
    }
    let textType = "text";

    let { conditionalRender } = this.props;
    if (this.props.component.textType) {
      textType = this.props.component.textType;
    }

    let isReadOnly1 = false;
    if ((pageData.unique_id && isReadOnly == 'edit') || (conditionalRender && conditionalRender == 'readonly') || (isReadOnly && isReadOnly != 'edit')) {
      isReadOnly1 = true;
    }

    let currentError
    if (errorMessages) {
      if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
        currentError = errorMessages[modalname][name];
      } else if (!modalname && errorMessages[name]) {
        currentError = errorMessages[name];
      }
    }
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();

    if (insertonly && !ShowHistory) {
      isReadOnly1 = true;
    }

    if (pageData.actionbuttons) {
      isReadOnly1 = true;
    }

    return (
      <div className={`form-group   ${this.props.component.widths.parent} `}>
        {mainHeader &&
          mainHeader != "" && (
            <label className=" col-form-label">
              {this.props.component.mainHeader}
            </label>
          )}
        {label &&
          label != "" && (
            <span>
              <label
                className=" col-form-label"
                id={tooltipID}
                className={`${this.state.extraClass
                  } col-form-label col-form-label-sm nopadding`}
              >
                {label}{" "}
                {" " + this.state.errorMessage != ""
                  ? this.state.errorMessage
                  : ""}
              </label>

              {
                description ? (<UncontrolledTooltip placement="right" target={tooltipID}>
                  {description}
                </UncontrolledTooltip>) : ""
              }
            </span>
          )}
        {" " + this.props.parentState.errorMessages != undefined &&
          this.props.parentState.errorMessages[name] ? (
          <span>
            <UncontrolledTooltip placement="right" target={tooltipID2}>
              {this.state.errorMessage}
            </UncontrolledTooltip>
          </span>
        ) : (
          ""
        )}
        {conditionalRender && conditionalRender != 'blank' &&
          <div className="input-group input-group-sm">
            {this.props.component.prepend && (
              <div className="input-group-prepend">
                <div className="input-group-text">
                  {this.props.component.prepend}
                </div>
              </div>
            )}
            {/* <div className="col-sm-4"> {this.props.component.prepend}</div> */}
            {/* {this.props.component.prepend && this.props.component.prepend!="" &&
             <span style={{marginRight:"10px" }}>{this.props.component.prepend}</span>
          } */}

            <input
              autoComplete="off"
              maxLength={maxlength}
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${currentError
                ? "validationErrorBox"
                : ""
                } ${!compressed ? "input-compressed" : ""}`}
              required={isRequired}
              readOnly={isReadOnly1}
              type={textType}
              step="0.01"
              pattern="[0-9]*"
              name={name}
              placeholder={placeHolder}
              value={boxvalue}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              onKeyDown={(e) => goToName(e, next_field, name, this)}
            />
            {this.props.component.append && (
              <div className="input-group-append">
                <div className="input-group-text">
                  {this.props.component.append}
                </div>
              </div>
            )}
          </div>
        }
      </div>
    );
  }
}

export default NumberOnlyCustom;
